import { render, staticRenderFns } from "./Parts.vue?vue&type=template&id=2c65694d&scoped=true&"
import script from "./Parts.vue?vue&type=script&lang=js&"
export * from "./Parts.vue?vue&type=script&lang=js&"
import style0 from "./Parts.vue?vue&type=style&index=0&id=2c65694d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c65694d",
  null
  
)

export default component.exports